import React from 'react';
interface SectionHeadingProps {
  eyebrow: string;
  title: React.ReactNode;
  subtitle?: string;
  tone?: 'light' | 'dark';
  align?: 'center' | 'left';
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = 'light',
  align = 'center'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  const isCenter = align === 'center';
  return <div className={isCenter ? 'mx-auto max-w-3xl text-center' : 'max-w-2xl'} data-id="element-256" data-mp="3k2043bmprg7b">
      <p className={`eyebrow flex items-center gap-2.5 text-[10px] sm:text-[11px] ${isCenter ? 'justify-center' : ''} ${isDark ? 'text-white/70' : 'text-clay'}`} data-id="element-257" data-mp="bl5a6lnw965d">
        <span className={`h-px w-6 ${isDark ? 'bg-white/30' : 'bg-clay/50'}`} aria-hidden="true" data-id="element-258" data-mp="1vbx1g83siz0" />
        {eyebrow}
        <span className={`h-px w-6 ${isDark ? 'bg-white/30' : 'bg-clay/50'} ${isCenter ? '' : 'hidden'}`} aria-hidden="true" data-id="element-259" data-mp="6sc51woijvsr" />
      </p>

      <h2 className={`mt-4 text-[31px] leading-[1.12] tracking-[-0.015em] sm:text-[42px] sm:leading-[1.08] lg:text-[50px] lg:leading-[1.06] font-semibold ${isDark ? 'text-white' : 'text-ink'}`} data-id="element-260" data-mp="uhejywrrjajk">
        {title}
      </h2>

      {subtitle ? <p className={`mt-5 text-[15.5px] leading-[1.75] sm:text-[17px] ${isCenter ? 'mx-auto max-w-2xl' : ''} ${isDark ? 'text-white/75' : 'text-ink-soft'}`} data-id="element-261" data-mp="1obnnje7entyo">
          {subtitle}
        </p> : null}
    </div>;
}